<template>
  <div class='bxTjzbhxr' v-if='kbxmlc'>
    <div class="box noBtn">
      <div class="clear">
        <p class="cont-title lf">推荐中标候选人</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getData"
            ></el-button>
          </el-input>
        </div>
        <div class="clear">
          <el-button v-if="role == 'Z'" :disabled="isNext" type="primary" class="rightButton" @click="tjdyzbhxr">推荐第一中标候选人</el-button>
        </div>
        <table-tem
          ref="table"
          :config="tableConfig"
          @changePage="tableChangePage"
          @changePages="changePages"
        >
        </table-tem>
        <!-- <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{}}家</span> -->
      </div>
      <el-button v-if="role == 'Z'" :disabled="isNext" @click="bxNextBtn" type="primary lcNext">下一步</el-button>
    </div>
  </div>
  <div v-else class='loading'>
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
        <span class='item-1'></span>
        <span class='item-2'></span>
        <span class='item-3'></span>
        <span class='item-4'></span>
        <span class='item-5'></span>
        <span class='item-6'></span>
        <span class='item-7'></span>
    </div>
  </div>
</template>

<script>
import tableTem from "@/components/tableTem/index.vue";
export default {
  components: {
    tableTem,
  },
  computed:{
    role() {
      return localStorage.getItem('role')?localStorage.getItem('role'):'T'
    },
    isNext() {
      return this.kbxmlc.zt == 2
    }
  },
  data() {
    return {
      waitLoading:false,
      djlcId:'',//节点流程id
      kbxmlc:{},
      tbdwmc: "", //查询条件
      tableConfig: {
        head: [
          {
            type: "selection",
            width: 40,
          },
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "fcqymc",
            title: "投标单位名称",
            align: "center",
          },
          {
            key: "fcbj",
            title: "投标报价",
            align: "center",
          },
          {
            key: "fcpm",
            title: "排名",
            align: "center",
          },
          {
            key: "fczbhxrbz",
            title: "推荐中标候选人",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
        unit: ''
      },
    };
  },
  watch:{
    unit(val){
      this.handleHead()
    }
  },
  created() {
    this.djlcId=this.$route.query.djlcId;
    this.getData()
  },
  methods: {
    handleHead() {
      this.tableConfig.head.forEach((el) => {
        if (el.key == "fcbj") {
          el.title = `${el.title}(${this.unit})`;
        }
      });
    },
    getData() {
      let para={
        djlcId:this.djlcId,
        tbdwmc: this.tbdwmc,
        currentPage: this.tableConfig.currentPage,
        pageSize: this.tableConfig.pageSize,
      }
      this.waitLoading=true
      this.$api.tjzbhxrList(para).then(res=>{
          if(res.data.meta.success){
            this.tableConfig.data = res.data.data.tbdwList
            this.tableConfig.total = res.data.data.total
            // this.bjgs = res.data.data.bjgs
            // this.zgs = res.data.data.zgs
            this.kbxmlc = res.data.data.kbxmlc
            this.unit =
              res.data.data.tbdwList.length !== 0
                ? res.data.data.tbdwList[0].tbbjdw
                : "";
          }else{
            this.$message({
              type:'error',
              message:res.data.meta.message
            })
          }
          this.waitLoading=false
      }).catch(()=>{})
    },
    tjdyzbhxr() {
      console.log(this.$refs.table.checkList);
      const list = this.$refs.table.checkList
      if(list.length == 1){
        this.$confirm("确定将"+ list[0].fcqymc + "（投标总报价" + list[0].fcbj + "）推荐为第一中标候选人？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let para={
              tbdwId:list[0].tbdwid,
              bz: '第一中标候选人',
            }
            this.waitLoading=true
            this.$api.bczbhxr(para).then(res=>{
                if(res.data.meta.success){
                  this.getData()
                }else{
                  this.$message({
                    type:'error',
                    message:res.data.meta.message
                  })
                }
                this.waitLoading=false
            }).catch(()=>{})
          })
          .catch(() => {});
      }else{
        this.$message.warning('请勾选1家投标单位')
      }
    },
    bxNextBtn(){
      let para={
        flag:this.kbxmlc.ycdz
      }
      this.waitLoading=true
      this.$emit('bxNextBtn',para)
    },
    // 分页功能
    tableChangePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>

<style lang='scss' scoped>
.rightButton{
  position: absolute;
  right: 10px;
}
.clear{
  clear: initial !important;
}
.pageNum{
  position: relative;
  bottom: 50px;
}
</style>
